import { Component, input } from '@angular/core';

export type CameraState = 'healthy' | 'unhealthy';

@Component({
  selector: 'app-pan-video-status-chip',
  templateUrl: './pan-video-status-chip.component.html',
  styleUrl: './pan-video-status-chip.component.scss',
  standalone: false,
})
export class PanVideoStatusChipComponent {
  public status = input.required<CameraState>();
}
